import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { isEqual } from 'lodash'
// import { isTouchDevice } from '../../../../utils/detect'

// Components
import Forsi from '../Forsi'
import RegistrationNumber from '../RegistrationNumber'
import OrderTypes from '../OrderTypes'
import Brand from '../Brand'
import ChassisNumber from '../ChassisNumber'
import Customer from '../Customer'
import FileArea from '../FileArea'
import Estimation from '../Estimation'

// Elements
import Check from '../../../elements/check'
import DropDown from '../../../elements/dropDown'
import Textarea from '../../../elements/textarea'
import Text from '../../../elements/text'
import Divider from '../../../elements/divider'
import TimeSpan from '../../../elements/timeSpan'

import MarkImage from '../MarkImage'
import Complaint from '../Complaint'

// Actions
import {
  createOrder,
  getOrderVehicleData
} from '../../../../actions/orders'
import { getAddressses } from '../../../../actions/address'
import { getInsuranceCompanies } from '../../../../actions/insurancecompanies'
import { getCarOwnerPortalInformation } from '../../../../actions/settings'

// Utils
import { translation } from '../../../../utils/helpers'
import { hasSubscriptionPermission, hasPartnerSubscriptionPermission, hasAccess } from '../../../../utils/auth'
import EnableCarOwnerPortalModal from '../../EnableCarOwnerPortalModal'

class NewBodyDraft extends Component {
  constructor (props) {
    super(props)
    this.newOrder = {}

    this.state = {
      customerClients: [],
      InsuranceCompanies: [],
      MostUsedInsuranceCompanies: [],
      CarRental: [],

      isLoading: false,

      CustomerId: 0,

      RegNumber: '',
      ChassisNumber: '',
      BrandOriginal: '', // brandname,
      ExtraData: {},

      OrderType: '0',

      fileContainerId: null,
      images: [],
      files: [],
      activeImage: {},

      evaluationAllowed: true,
      Estimation: '0',
      Estimation_comment: '',

      InsuranceCompanyId: 0,

      PickupAltLocationChecked: '0',
      PickupAltLocationId: 0,
      PickupAltLocation_comment: '',
      DeliveryAltLocationChecked: '0',
      DeliveryAltLocationId: 0,
      DeliveryAltLocation_comment: '',

      CarOwnerName: '',
      CarOwnerLastName: '',
      CarOwnerPhone: '',
      CarOwnerMail: '',
      EnableCarOwnerPortal: false,
      IsCarOwnerPortalAccess: '0',
      ShowCarOwnerPortalModal: false,
      NewOrderId: null,

      CarRentalChecked: '0',
      CarRentalId: 0,

      EstimatedProcessTime: null,
      EstimatedProcessTimeCalculated: null,
      estimatedProcessTimeValid: true,
      BodyShopLeadTime: null,

      orderdata: {},
      listingID: '0'
    }

    this.submitOrder = this.submitOrder.bind(this)
    this.createOrder = this.createOrder.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
    this.onTimeSpanBlur = this.onTimeSpanBlur.bind(this)
    this.updateState = this.updateState.bind(this)
    this.addCarOwnerInformation = this.addCarOwnerInformation.bind(this)
    this.onCloseCarOwnerMadal = this.onCloseCarOwnerMadal.bind(this)
    this.createNewOrder = this.createNewOrder.bind(this)
    // this.createCustomSelect = this.createCustomSelect.bind(this)
  }

  componentDidMount () {
    this.props.updateModal({
      bottomBarProps: {
        actionLabelText: translation('21'),
        onActionClick: this.submitOrder
      }
    })

    if (this.props.allowNoCustomer && this.props.tabView === 'draft') {
      this.setState({ CustomerId: -1 })
    } else {
      const ownShopCustomer = this.props.customers.find(cust => cust.IsOwnShop === true)
      if (ownShopCustomer !== undefined) {
        this.setState({ CustomerId: ownShopCustomer.CustomerId })
      }
    }
    this.props.getInsuranceCompanies().then(res => {
      this.setState({
        InsuranceCompanies: res.data.Item2,
        MostUsedInsuranceCompanies: res.data.Item1
      })
    })

    if (this.props.carRentalDefaultInfo) {
      this.setDefaultRentalCarInfo(this.props.carRentalDefaultInfo)
    }

    if (this.props.auth.permissions.AllowCarOwnerPortal) {
      this.props.getCarOwnerPortalInformation().then(res => {
        this.setState({ EnableCarOwnerPortal: res.data.CarOwnerPortalEnabled })
      })
    }

    if (this.props.bodyShopDefaultLeadTime) {
      this.setState({ BodyShopLeadTime: this.props.bodyShopDefaultLeadTime })
    }
  }

  componentWillReceiveProps (nextProps) {
    if (!isEqual(nextProps, this.props)) {
      if (nextProps.carRentalDefaultInfo) {
        this.setDefaultRentalCarInfo(nextProps.carRentalDefaultInfo)
      }
    }
  }

  setDefaultRentalCarInfo (carRentalDefaultInfo) {
    if (carRentalDefaultInfo.carRentalId) {
      this.setState({
        CarRentalChecked: '1',
        CarRentalId: carRentalDefaultInfo.carRentalId + ''
      })
    }
  }

  setErrors (errors) {
    this.setState(errors)
    let el = ReactDOM.findDOMNode(this.refs.addorderpopup)
    if (el && el.parentNode) {
      el.parentNode.scrollTop = 0
    }
  }

  submitOrder (e) {
    e.preventDefault()

    this.setState({ isLoading: true, error: '' })

    // If user filled in regnumber, but chassis is empty, try to look up data before continuing.
    if (this.state.RegNumber !== null && this.state.RegNumber !== '' &&
      (this.state.ChassisNumber === null || this.state.ChassisNumber === '') &&
      hasSubscriptionPermission(this.props.auth, 10, 0)) {
      this.setState({ ExtraData: {} })

      this.props.getOrderVehicleData(this.state.RegNumber, 'RegNumber').then(res => {
        if (res.data.BrandOriginal !== null) {
          this.setState({
            ChassisNumber: res.data.ChassisNumber,
            BrandOriginal: res.data.BrandName,
            ExtraData: res.data
          }, () => {
            this.createOrder()
          })
        }
      }, () => {
      })
      this.createOrder()
    } else {
      this.createOrder()
    }
  }

  createOrder () {
    if (this.state.isLoading) return

    let customerId = 0
    if (this.props.auth.user.CustomerId === '-1') {
      customerId = this.state.CustomerId
    } else {
      customerId = parseInt(this.props.auth.user.CustomerId)
    }

    // VALIDATION START
    let errors = []

    if (customerId === 0) {
      errors.push(translation('1736')) // please select customer
    }

    if (this.state.OrderType === '0') {
      errors.push(translation('13454')) // please select order type
    }

    if (!this.state.estimatedProcessTimeValid) {
      errors.push(translation(16837))   // Estimated process time must be specified in valid format
    }

    if (errors.length > 0) {
      this.setErrors({
        isLoading: false
      })
      // Toastr
      let errorText = ''
      for (let i = 0; i < errors.length; i++) {
        errorText += '<br />' + errors[i]
      }
      window.toastr.error(errorText, translation('216'))
      return false
    }
    // VALIDATION END

    // IsEvaluation
    let IsEvaluation = false
    if (this.state.Estimation !== '0' && this.state.evaluationAllowed) {
      IsEvaluation = true
    }

    // Evaluation comment
    let evaluationComment = ''
    if (IsEvaluation) {
      evaluationComment = this.state.Estimation_comment
    }

    // PickupAltLocation comment
    let PickupAltLocationComment = ''
    let PickupAltLocationId
    if (this.state.PickupAltLocationChecked !== '0') {
      PickupAltLocationId = this.state.PickupAltLocationId
      PickupAltLocationComment = this.state.PickupAltLocation_comment !== ''
        ? this.state.PickupAltLocation_comment
        : undefined
    }
    // DeliveryAltLocation comment
    let DeliveryAltLocationComment = ''
    let DeliveryAltLocationId
    if (this.state.DeliveryAltLocationChecked !== '0') {
      DeliveryAltLocationId = this.state.DeliveryAltLocationId
      DeliveryAltLocationComment = this.state.DeliveryAltLocation_comment !== ''
        ? this.state.DeliveryAltLocation_comment
        : undefined
    }

    // Car rental default info
    let DefaultPickupDate = null
    let PickupCarRentalCalc = false
    if (this.props.carRentalDefaultInfo && this.props.carRentalDefaultInfo.date) {
      DefaultPickupDate = this.props.carRentalDefaultInfo.date
      PickupCarRentalCalc = true
    }

    // Files
    let files = []
    if (this.state.images.length !== 0 || this.state.files.length !== 0) {
      files = [...this.state.images, ...this.state.files]
    }

    // Brand
    let BrandName = this.state.ExtraData.BrandName
    if (!BrandName) BrandName = this.state.BrandOriginal

    // Estimated process time.
    let estimatedProcessTime = this.state.EstimatedProcessTimeCalculated === null ? null : this.state.EstimatedProcessTimeCalculated.decimal
    if (estimatedProcessTime === null || Number.isNaN(estimatedProcessTime) || estimatedProcessTime === 0) {
      estimatedProcessTime = null
    } else {
      estimatedProcessTime *= 60
    }

    this.props.modal.isLoading(true)
    if (this.props.options && this.props.options.pickup) {
      DefaultPickupDate = this.props.options.pickup
    }

    this.setState({ isLoading: true }, () => {
      const order = {
        RegNr: this.state.RegNumber,
        ChassisNumber: this.state.ChassisNumber,
        OrderType: this.state.OrderType,
        BrandOriginal: this.state.ExtraData.BrandOriginal,
        Model: this.state.ExtraData.Model,
        BrandName: BrandName,
        BrandCode: this.state.ExtraData.BrandCode,
        RegistrationDate: this.state.ExtraData.RegistrationDate,
        CustomerId: customerId,
        IsEvaluation: IsEvaluation,
        Case: {
          Comment: evaluationComment
        },
        ImageTypes: files,
        FileContainerId: this.state.fileContainerId,
        DefaultPickupDate: DefaultPickupDate,
        PickupCarRentalCalc: PickupCarRentalCalc,
        EstimatedProcessTimeInMin: estimatedProcessTime,
        BodyShopLeadTime: this.state.BodyShopLeadTime,
        BodyShopData: {
          DepartmentType: this.props.auth.departmentType, // 1
          PickupAltLocationId: PickupAltLocationId,
          DeliveryAltLocationId: DeliveryAltLocationId,
          CarRentalId: this.state.CarRentalChecked === '1' ? this.state.CarRentalId : undefined,
          CarOwnerName: this.state.CarOwnerName,
          CarOwnerLastName: this.state.CarOwnerLastName,
          CarOwnerPhone: this.state.CarOwnerPhone,
          CarOwnerMail: this.state.CarOwnerMail,
          IsCarOwnerPortalAccess: this.state.IsCarOwnerPortalAccess === '1',
          PickupAltLocationComment: PickupAltLocationComment,
          DeliveryAltLocationComment: DeliveryAltLocationComment,
          InsuranceCompanyId: this.state.InsuranceCompanyId
        }
      }

      // store order in newOrder object
      this.newOrder = order
      // console.log('state.IsCarOwnerPortalAccess', this.state.IsCarOwnerPortalAccess, 'BodyShopdata.IsCarOwnerPortalAccess', order.BodyShopData.IsCarOwnerPortalAccess)

      if (this.state.EnableCarOwnerPortal && order.BodyShopData.IsCarOwnerPortalAccess && this.state.CarOwnerMail === '' && this.state.CarOwnerPhone === '') {
        // display enable car owner portal modal
        this.props.modal.isLoading(false)
        this.setState({
          ShowCarOwnerPortalModal: true,
          isLoading: false
        })
      } else {
        this.createNewOrder(order)
      }
    })
  }

  // Create new order function
  createNewOrder (order) {
    this.props.createOrder(order)
        .then(res => {
          this.props.modal.isLoading(false)
          this.props.uploadImageMarkings(this.state.images)
          if (this.state.OrderType === '5' && res.data.PreviousOrders.length > 0) {
            this.setState({
              isLoading: false,
              orderdata: res.data
            }, () => this.props.updateModal({ tabView: 'complaint' }))
          } else {
            // Toastr
            // window.toastr.success(translation('13439'), translation('13424'))
            this.props.onDraftCreated && this.props.onDraftCreated(res.data.OrderId)
            this.props.redirectToOrder(res.data.OrderId)
          }
        })
        .catch((err) => {
          this.props.modal.isLoading(false)
          this.setErrors({ isLoading: false })
          // Toastr
          if (err.response.data.DictionaryKey !== undefined) {
            window.toastr.error(translation(err.response.data.DictionaryKey), translation('216'))
          } else if (err.response.data.Errors !== undefined) {
            // Toastr
            let errorText = ''
            let errors = err.response.data.Errors
            for (let i = 0; i < errors.length; i++) {
              if (errors[i].StatusCode === 4) {
                this.setState({ Estimation: '1' })
              }
              errorText += '<br />' + translation(errors[i].DictionaryKey)
            }
            window.toastr.error(errorText, translation('216'))
          }
        })
  }

  // add car owner info from the modal and create order
  addCarOwnerInformation (phone, mail) {
    this.setState({
      ShowCarOwnerPortalModal: false
    }, () => {
      this.newOrder.BodyShopData.CarOwnerPhone = phone
      this.newOrder.BodyShopData.CarOwnerMail = mail
      this.props.modal.isLoading(true)
      this.createNewOrder(this.newOrder)
    })
  }

  // close car owner modal and create order
  onCloseCarOwnerMadal () {
    this.props.modal.isLoading(true)
    this.createNewOrder(this.newOrder)
  }

  onInputChange (e) {
    const { name, type, checked } = e.target
    let { value } = e.target
    if (type === 'checkbox' && !checked) value = '0'
    if (name === 'CustomerId') value = parseInt(value)
    if (name === 'BodyShopLeadTime') {
      value = parseInt(value)
      if (isNaN(value)) {
        value = ''
      }
      if (value === '' || value < 1 || value > 99) {
        window.toastr.error(translation(18340), translation('216'))
      }
    }

    this.setState({ [name]: value })
    // Retrieve info
    if ((name === 'PickupAltLocationChecked' || name === 'DeliveryAltLocationChecked') && (!this.state.customerClients || this.state.customerClients.length === 0)) {
      let id = (hasAccess([4], this.props.auth.user.UserType) && this.props.auth.user.CustomerId > 0) ? this.props.auth.user.CustomerId : this.props.auth.user.ShopId
      this.props.getAddressses(id).then((res) => {
        this.setState({
          customerClients: res.data
        })
      })
    }
  }

  onTimeSpanBlur (e) {
    if (e.target.currentFormat === -1 && this.state.EstimatedProcessTime) {  // (-1 = invalid format)
      window.toastr.error(translation(16837), translation('216'))
      this.setState({ estimatedProcessTimeValid: false })
    } else {
      this.setState({
        EstimatedProcessTimeCalculated: e.target.value,
        estimatedProcessTimeValid: true
      })
    }
  }

  updateState (data, cb) {
    this.setState(data, cb)
  }

  renderAltLocation (titleKey, commentTitleKey, type) {
    const base = type + 'AltLocation'
    const checkedName = base + 'Checked'
    const idName = base + 'Id'
    const commentName = base + '_comment'

    return (
      <div>
        <Check spacing={1} labelText={translation(titleKey)} id={checkedName} name={checkedName} value='1' onChange={this.onInputChange} checked={this.state[checkedName] !== '0'} />
        {this.state[checkedName] === '1' && (
          <div className='pg-mb-1'>
            <DropDown name={idName} value={this.state[idName]} onChange={this.onInputChange}>
              <option value='0'>{translation('227')}</option>
              {this.state.customerClients !== undefined && this.state.customerClients.map((val, index) => {
                return (
                  <option value={val.CustomerClientId} key={index}>{translation(val.Name)}</option>
                )
              })}
            </DropDown>
          </div>
        )}
        {this.state[checkedName] === '1' && (
          <Textarea labelText={translation(commentTitleKey)} name={commentName} onChange={this.onInputChange} value={this.state[commentName]} />
        )}
      </div>
    )
  }

  renderInsuranceCompany () {
    if (!hasSubscriptionPermission(this.props.auth, 10)) return null

    const renderOptions = () => {
      if (this.state.InsuranceCompanies.length > 0) {
        let insuranceCompaniesRanked = []
        let rankedList = []
        rankedList.push({ value: 0, label: translation('14863') })

        const renderOptGroup = (company, index) => {
          return { value: company.InsuranceCompanyId, label: company.Company }
        }

        if (this.state.MostUsedInsuranceCompanies.length > 0) {
          insuranceCompaniesRanked = this.state.MostUsedInsuranceCompanies.map(renderOptGroup)
          rankedList.push(
            {
              label: translation('16301'),
              options: insuranceCompaniesRanked
            }
          )
        }
        let insuranceCompanies = this.state.InsuranceCompanies.map(renderOptGroup)

        rankedList.push(
          {
            label: translation('13044'),
            options: insuranceCompanies
          }
        )

        return rankedList
      }
      return []
    }

    const { InsuranceCompanyId } = this.state

    return (
      this.state.InsuranceCompanies !== undefined && (
        <DropDown
          isGrouping
          labelText={translation('418')}
          name='InsuranceCompanyId'
          value={InsuranceCompanyId}
          onChange={this.onInputChange}
          options={renderOptions()}
        />
      )
    )
  }

  renderBodyShopLeadTime () {
    let name = 'BodyShopLeadTime'
    const onBlur = () => {
      let bodyShopLeadTime = this.state.BodyShopLeadTime
      let inValidbodyShopLeadTime = bodyShopLeadTime === '' || bodyShopLeadTime < 1 || bodyShopLeadTime > 99 || isNaN(bodyShopLeadTime)
      if (inValidbodyShopLeadTime) {
        this.setState({ BodyShopLeadTime: this.props.bodyShopDefaultLeadTime })
      }
    }

    return (
      <Text key={name} labelText={translation(18341)} type='text' name={name} value={this.state[name]} onChange={this.onInputChange} onBlur={onBlur} autoComplete='off' />
    )
  }

  renderCarInfo () {
    if (!hasSubscriptionPermission(this.props.auth, 10)) return null
    const renderField = (titleKey, name) => {
      return (
        <Text key={name} labelText={translation(titleKey)} type='text' name={name} value={this.state[name]} onChange={this.onInputChange} autoComplete='off' />
      )
    }

    return [
      renderField('16776', 'CarOwnerName'),
      renderField('16777', 'CarOwnerLastName'),
      renderField('14762', 'CarOwnerPhone'),
      renderField('14763', 'CarOwnerMail'),
      this.renderCarOwnerPortalAccess(),
      this.renderEnableCarOwnerPortalModal()
    ]
  }

  renderCarOwnerPortalAccess () {
    if (!this.state.EnableCarOwnerPortal) return null
    return (
      <Check labelText={translation('18158')} id='isCarOwnerPortalAccess' name='IsCarOwnerPortalAccess' value='1' onChange={this.onInputChange} checked={this.state.IsCarOwnerPortalAccess !== '0'} />
    )
  }

  renderEnableCarOwnerPortalModal () {
    if (!this.state.EnableCarOwnerPortal) return null
    return (
      <EnableCarOwnerPortalModal
        router={this.props.router}
        orderId={this.state.NewOrderId}
        show={this.state.ShowCarOwnerPortalModal}
        phone={this.state.CarOwnerPhone}
        addCarOwnerInformation={this.addCarOwnerInformation}
        onCloseCarOwnerMadal={this.onCloseCarOwnerMadal} />
    )
  }

  renderCarRental () {
    return (
      <Check labelText={translation('629')} id='carRentalChecked' name='CarRentalChecked' value='1' onChange={this.onInputChange} checked={this.state.CarRentalChecked !== '0'} />
    )
  }

  render () {
    const defaultProps = {
      updateState: this.updateState,
      onInputChange: this.onInputChange,
      updateModal: this.props.updateModal
    }

    switch (this.props.tabView) {
      case 'image':
        return <MarkImage currentImg={this.state.activeImage} images={this.state.images} {...defaultProps} />
      case 'complaint':
        return <Complaint
          listingID={this.state.listingID}
          orderdata={this.state.orderdata}
          setErrors={this.setErrors}
          redirectToOrder={this.props.redirectToOrder}
          onModalClose={this.props.onModalClose}
          {...defaultProps}
          bodyShop
        />
      case 'draft':
        return (
          <form className='addOrderPopup clearfix' ref='addorderpopup'>
            <Forsi redirectToOrder={this.props.redirectToOrder} />
            <RegistrationNumber regNr={this.state.RegNumber} {...defaultProps} />
            <Brand selected={this.state.BrandOriginal} {...defaultProps} />
            <ChassisNumber chassisNumber={this.state.ChassisNumber} {...defaultProps} />
            {hasSubscriptionPermission(this.props.auth, 20) && this.renderAltLocation('14764', '14769', 'Pickup')}
            {hasSubscriptionPermission(this.props.auth, 20) && this.renderAltLocation('14765', '14770', 'Delivery')}
            <Divider />

            {this.props.auth.user.CustomerId === '-1' && <Customer selected={this.state.CustomerId} {...defaultProps} bodyShop />}
            <div className='empty_space clearfix' />
            {this.renderInsuranceCompany()}
            <div className='empty_space clearfix' />
            {this.renderCarInfo()}
            <div className='empty_space clearfix' />
            <TimeSpan name='EstimatedProcessTime' value={this.state.EstimatedProcessTime || ''} labelText={16835} onBlur={this.onTimeSpanBlur} onChange={this.onInputChange} />
            {this.renderBodyShopLeadTime()}
            {this.renderCarRental()}
            <OrderTypes selected={this.state.OrderType} {...defaultProps} bodyShop />

            <Divider />
            <div>
              {(hasSubscriptionPermission(this.props.auth, 10) || hasPartnerSubscriptionPermission(this.props.auth, 10)) && (<FileArea
                fileContainerId={this.state.fileContainerId}
                files={this.state.files}
                images={this.state.images}
                setErrors={this.setErrors}
                {...defaultProps}
              />)}
              {(hasSubscriptionPermission(this.props.auth, 30, 25) || hasPartnerSubscriptionPermission(this.props.auth, 10)) && this.props.hasPaintPartner && (
                <Estimation
                  evaluationAllowed={this.state.evaluationAllowed}
                  showComment={this.state.Estimation === '1'}
                  comment={this.state.Estimation_comment}
                  {...defaultProps}
                />
              )}
            </div>
          </form>
        )
    }
  }
}

NewBodyDraft.propTypes = {
  tabView: PropTypes.string.isRequired,
  uploadImageMarkings: PropTypes.func.isRequired,
  redirectToOrder: PropTypes.func.isRequired,
  updateModal: PropTypes.func.isRequired,
  modal: PropTypes.object.isRequired,
  onModalClose: PropTypes.func.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    customers: state.common.customers,
    allowNoCustomer: state.auth.allowNoCustomer,
    hasPaintPartner: state.common.hasPaintPartner,
    bodyShopDefaultLeadTime: state.common.bodyShopDefaultLeadTime
  }
}

export default connect(mapStateToProps, {
  createOrder,
  getOrderVehicleData,
  getAddressses,
  getInsuranceCompanies,
  getCarOwnerPortalInformation
})(NewBodyDraft)



// WEBPACK FOOTER //
// ./src/app/shared/modals/NewOrdersModal/NewBodyDraft/index.js